<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改角色信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="roleInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">角色名</label>
        <Input style="display: inline-block; width: 200px;" :disabled="true" v-model="roleInfo.name"
               placeholder="请输入角色名">
        </Input>
      </FormItem>
      <FormItem prop="nickName">
        <label style="display: inline-block; width: 60px;">昵称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="roleInfo.nickName"
               placeholder="请输入昵称">
        </Input>
      </FormItem>
      <FormItem prop="description">
        <label style="display: inline-block; width: 60px;">描述</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="roleInfo.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'RoleDetailModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            {required: true, message: '角色名不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    data() {
      return {
        modify: false,
        roleInfo: {
          id:null,
          name: null,
          nickName: null,
          description: null
        }
      }
    },
    methods: {
      ...mapActions([
        'RoleServ_GetDetail',
        'RoleServ_ModifyObj'
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改角色信息',
            content: '<p>确认修改角色信息</p>',
            onOk: () => {
              store.dispatch('RoleServ_ModifyObj', {
                params: this.roleInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let roleId = this._initValue
              store.dispatch('RoleServ_GetDetail', {
                params: {id: roleId}
              }).then(() => {
                this.roleInfo = store.getters.get_Role_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if (val) {
          this.id = null
          this.roleInfo.name = null
          this.roleInfo.nickName = null
          this.roleInfo.description = null
          let roleId = this._initValue
          if (roleId) {
            store.dispatch('RoleServ_GetDetail', {
              params: {id: roleId}
            }).then(() => {
              this.roleInfo = store.getters.get_Role_GetDetailResult;
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules() {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
